import React from 'react';

/** Heuristic: show as <img> vs iframe (PDFs / generic URLs use iframe). */
export function isLikelyImageUrl(url: string): boolean {
  try {
    const path = new URL(url, window.location.origin).pathname;
    return /\.(png|jpe?g|gif|webp|svg)$/i.test(path);
  } catch {
    return /\.(png|jpe?g|gif|webp|svg)(\?|$)/i.test(url);
  }
}

type Props = {
  url: string;
  /** CSS module prefix e.g. "policy-view" → policy-view-iframe */
  variant?: 'viewer' | 'acceptance';
};

const PolicyDocumentEmbed: React.FC<Props> = ({ url, variant = 'viewer' }) => {
  const imgClass = variant === 'acceptance' ? 'policy-accept-doc-img' : 'policy-view-doc-img';
  const frameClass = variant === 'acceptance' ? 'policy-accept-doc-iframe' : 'policy-view-iframe';

  if (isLikelyImageUrl(url)) {
    return <img src={url} alt="" className={imgClass} />;
  }
  return <iframe src={url} title="Policy document" className={frameClass} />;
};

export default PolicyDocumentEmbed;
